import React, { useState, useEffect } from "react";

function CornerEmote() {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // Show animated emote for 1 second
      setIsAnimated(true);

      // Switch back to static emote after 1 second
      setTimeout(() => {
        setIsAnimated(false);
      }, 800);
    }, 5000); // Repeat every 6 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="corner-emote">
      <a
        href="https://boosty.to/k0kcakep/donate"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://cdn.7tv.app/emote/01FNP5MT10000EJT2EVEY3ET7C/4x.gif"
          alt=""
          className={`animated-emote ${isAnimated ? "active" : ""}`}
        />
        <img
          src="https://cdn.7tv.app/emote/01JVFJMYGV9ZMKS946YFVKVQ65/4x.png"
          alt=""
          className={`static-emote ${!isAnimated ? "active" : ""}`}
        />
      </a>
    </div>
  );
}

export default CornerEmote;
